import ajax from './ajax'

//export const BASE = 'http://localhost:8080/api'
//export const BASE = 'https://invesserver.tokyo/'


const defaultBase = 'https://cloudoz.jp/';
const rawBase = process.env.REACT_APP_API_BASE || defaultBase;
export const BASE = rawBase.endsWith('/') ? rawBase : `${rawBase}/`;
//export const BASE = 'http://133.125.53.153:8080/'
export const DOWNLOAD = BASE + 'api/mail/'
export const PRICEDOWNLOAD = BASE + 'api/pricedata/download/'
export const CORRELATIONDOWNLOAD = BASE + 'api/corrdata/download/'

export const reqPrice = (code,tradeDate) => ajax(BASE + 'api/getprice', {code, tradeDate}, 'POST')

export const reqBonds = () => ajax(BASE + 'api/getbonds', {})

export const reqLogin = (mailAddress, password) => ajax(BASE + 'api/login', {mailAddress, password}, 'POST')

export const reqAddAccount = (user) => ajax(BASE + 'api/adduser', user, 'POST')

export const reqEnums = () => ajax(BASE + 'api/enum', {})

export const reqGoogleToken = (token) => ajax(BASE + 'api/verify_google_token', {token}, 'POST')

export const reqActiveMail = (mailAddress) => ajax(BASE + 'api/sendactivemail', {mailAddress}, 'POST')

export const reqResetMail = (mailAddress) => ajax(BASE + 'api/resetmail', {mailAddress}, 'POST')

export const reqResetCodeConfirm = (code,mailAddress) => ajax(BASE + 'api/resetcodeconfirm', {code,mailAddress}, 'POST')

export const reqResetPassword = (mailAddress,password) => ajax(BASE + 'api/resetpassword', {mailAddress,password}, 'POST')

export const reqAccount = (code) => ajax(BASE + 'api/getuser', {code},'POST')

export const reqUsers = () => ajax(BASE + 'api/user/list', {},'POST')

export const reqDeleteUser = (securityCode) => ajax(BASE + 'api/user/delete', {securityCode}, 'POST')

export const reqUpdateAccount = (user) => ajax(BASE + 'api/user/updateaccount', user, 'POST')

export const reqAddOrUpdateUser = (user) => ajax(BASE + 'api/user/addorupdateuser', user, 'POST')

export const reqUpdateUserActive = (securityCode,actived) => ajax(BASE + 'api/user/updateactived', {securityCode,actived}, 'POST')

export const reqUpdateUserRole = (securityCode,role) => ajax(BASE + 'api/user/updaterole', {securityCode,role}, 'POST')

export const reqCheckUserId = (userId) => ajax(BASE + 'api/user/checkuserId', {userId}, 'POST')

export const reqBondPricing = (data) => ajax(BASE + 'api/bondpricing', data, 'POST')

export const reqSearchData = (key) => ajax(BASE + 'api/stocks/'+ key, {})

export const reqGetETFData = () => ajax(BASE + 'api/getbond-etfs', {})

export const reqGetAllETFData = (locale,type) => ajax(BASE + 'api/getallbond-etfs', {locale,type})
export const reqSearchETFData = (locale,type,keyword,limit=100) => ajax(BASE + 'api/getallbond-etfs', {locale,type,keyword,limit})
export const reqSearchETFPage = (locale,type,keyword,page,pageSize,sortOrder='',sortField='asset') => ajax(BASE + 'api/getallbond-etfs', {locale,type,keyword,page,pageSize,sortOrder,sortField})

const mapConstraintParamToSnakeCase = (param = {}) => ({
  asset: param?.asset ?? param?.Asset ?? '',
  asset_en: param?.asset_en ?? param?.AssetEn ?? '',
  sector_code: param?.sector_code ?? param?.SectorCode ?? null,
  optimization_mode: param?.optimization_mode ?? param?.optimizationMode ?? 'ASSET',
  representative_instrument_id: param?.representative_instrument_id ?? param?.Code ?? '',
  express: param?.express ?? param?.Express ?? '',
  express_value: param?.express_value ?? param?.ExpressValue ?? null,
})

const mapSectorOptimalItemToSnakeCase = (item = {}) => ({
  sector_name: item?.sector_name ?? item?.Asset ?? '',
  sector_code: item?.sector_code ?? item?.SectorCode ?? null,
  asset_en: item?.asset_en ?? item?.AssetEn ?? 'JP Stocks',
  representative_instrument_id: item?.representative_instrument_id ?? item?.instrument_id ?? item?.Code ?? '',
  percentage: item?.percentage ?? item?.OptimalPercent ?? 0,
  color_hex: item?.color_hex ?? item?.Color ?? '',
  color_name: item?.color_name ?? '',
  instrument_id: item?.instrument_id ?? item?.representative_instrument_id ?? item?.Code ?? '',
  instrument_name: item?.instrument_name ?? item?.Name ?? '',
  sort_order: item?.sort_order ?? null,
})

export const reqSaveOptimalData = (data) => ajax(BASE + 'api/saveoptimal', {
  ...data,
  optimization_mode: data?.optimization_mode ?? data?.optimizationMode,
  sector_optimal_items: Array.isArray(data?.sector_optimal_items)
    ? data.sector_optimal_items
    : Array.isArray(data?.sectorOptimalItems)
      ? data.sectorOptimalItems.map(mapSectorOptimalItemToSnakeCase)
      : undefined,
}, 'POST')

export const reqReCalcOptimalData = (data) => ajax(BASE + 'api/recalcoptimal', data, 'POST')
export const reqGetSectorOptimalData = (data) => ajax(BASE + 'api/sectoroptimal', data, 'POST')
export const reqGetJpSectorWeight = (data) => ajax(BASE + 'api/portfolio/jp-sector-weight', data, 'POST')
export const reqGetWorldStockBreakdown = (data) => ajax(BASE + 'api/portfolio/world-stock-breakdown', data, 'POST')
export const reqGetOptimalData = (data) => {
  const url = BASE + 'api/optimize'
  return ajax(url, data, 'POST')
}
export const reqGetOptimalDataByRisk = (data) => {
  const url = BASE + 'api/optimizebyrisk'
  return ajax(url, data, 'POST')
}
export const reqGetSimulateData = (data) => ajax(BASE + 'api/future-simulation', data, 'POST')
export const reqUpdateModelParam = (uid,portfolio,params,ObservValue) => ajax(BASE + 'api/modelparam/update', {
  uid,
  portfolio,
  observ_value: ObservValue,
  params: Array.isArray(params) ? params.map(mapConstraintParamToSnakeCase) : [],
}, 'POST')
export const reqGetPortfolios = (uid,isJPYMode,portfolio) => ajax(BASE + 'api/portfolios', {uid,isJPYMode,portfolio}, 'POST')
export const reqGetPortfolioFile = (data) => ajax(BASE + 'api/createportfoliofile', data, 'POST')

export const reqGetPortfolio = (id) => ajax(BASE + 'api/portfolio/get', {id}, 'POST')
export const reqDelPortfolio = (uid,portfolio) => ajax(BASE + 'api/portfolio/del', {uid,portfolio}, 'POST')
export const reqUpdatePortfolioName = (uid,portfolio,newPortfolio) => ajax(BASE + 'api/portfolio/updateName', {uid,portfolio,newPortfolio}, 'POST')
export const reqAddPortfolioName = (uid,portfolio) => ajax(BASE + 'api/portfolio/add', {uid,portfolio}, 'POST')
export const reqUpdateTransaction = (data) => ajax(BASE + 'api/transaction/update', data, 'POST')
export const reqGetFinancialInstitutions = () => ajax(BASE + 'api/accounts/institutions', {}, 'POST')
export const reqGetUserAccounts = (UserId) => ajax(BASE + 'api/accounts/list', {UserId}, 'POST')
export const reqGetManagedUserAccounts = (UserId) => ajax(BASE + 'api/accounts/manage-list', {UserId}, 'POST')
export const reqSaveUserAccount = (data) => ajax(BASE + 'api/accounts/save', data, 'POST')
export const reqPreviewDividend = (data) => ajax(BASE + 'api/transaction/dividend-preview', data, 'POST')
export const reqGetTransactionPlanStatus = (tranId) => ajax(BASE + 'api/transaction/plan-status', {tranId}, 'POST')
export const reqDelTransaction = (id, DeleteScope = 'single') => ajax(BASE + 'api/transaction/del', {id, DeleteScope}, 'POST')
export const reqGetFXRate = (name,date) => ajax(BASE + 'api/fxrate', {name,date}, 'POST')


export const reqGetPriceFile = (filename) => ajax(BASE + 'api/pricedata/download/'+filename,{})
export const getETFAssetName = (code) => ajax(BASE + 'api/getetfasset/'+ code, {})

export const getTranslateText = () => ajax(BASE + 'api/translatetext', {})


export const reqCategorys = (parentId) => ajax(BASE + 'api/manage/category/list', {parentId})

export const reqAddCategory = ({parentId,categoryName}) => ajax(BASE + 'api/manage/category/add', {parentId,categoryName},'POST')

export const reqUpdateCategory = ({categoryId,categoryName}) => ajax(BASE + 'api/manage/category/update', {categoryId,categoryName},'POST')

export const reqProducts = ({pageNum,pageSize}) => ajax(BASE + 'api/manage/product/list', {pageNum,pageSize})

export const reqSearchProducts = ({pageNum,pageSize,searchType,searchName}) => ajax(BASE + 'api/manage/product/search', {pageNum,pageSize,[searchType]:searchName})

export const reqUpdatePruductStatus = ({productId,status}) => ajax(BASE + 'api/manage/product/updatestatus', {productId,status},'POST')
